var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H5.5C3.567 2 2 3.567 2 5.5V18.5C2 20.433 3.567 22 5.5 22H9M9 2H18.5C20.433 2 22 3.567 22 5.5V18.5C22 20.433 20.433 22 18.5 22H9M9 2V22M4.5 6H6.5M4.5 9H6.5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBar);
export default __webpack_public_path__ + "static/media/SideBar.edfc71bec987f83dd7286318571743e5.svg";
export { ForwardRef as ReactComponent };